.skeletonWrapper {
  width: 150px;
}

.skeleton {
  width: 100%;
}

.dropdownItem,
.tag {
  cursor: pointer;
}

.panel {
  width: 100%;
}

.panelHeader {
  cursor: default;
}
